import $ from 'jquery'
import React from 'react'


function ChoiceField({choices, value, onChange}) {
    let options = choices.map((choice)=>(
        <option value={choice[0]} key={choice[0]}>{choice[1]}</option>
    ));
    return (
        <select name={name} value={value}
                onChange={(e)=>{if (onChange) onChange($(e.target).val());}}>
            {options}
        </select>
    );
}

export default ChoiceField


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/ChoiceField.js